import { useRef, useLayoutEffect, useState } from "react"
import PropTypes from "prop-types"
import { get } from "lodash"
import Tooltip from "components/material/tooltip"
import useResizeObserver from "hooks/resize-observer"

import "./styles.scss"

function getAbsoluteMaxWidth(maxWidth, parentWidth) {
  return typeof maxWidth === "string" && maxWidth.endsWith("%")
    ? (parseFloat(maxWidth) / 100) * parentWidth
    : maxWidth
}

export default function Ellipsable({ width: maxWidth, children, ...props }) {
  const targetRef = useRef()
  const [clippedAtWidth, setClippedAtWidth] = useState(0)
  const [width, parentWidth] = useResizeObserver(targetRef)

  useLayoutEffect(() => {
    // Calculate absolute width if percentage is provided
    const absoluteMaxWidth = getAbsoluteMaxWidth(maxWidth, parentWidth)

    // Prevent the new ellipsis width from triggering a resize
    if (width >= absoluteMaxWidth) {
      setClippedAtWidth(absoluteMaxWidth)
    }
  }, [clippedAtWidth, maxWidth, width, parentWidth])

  // We are only interested in the text coming from children, plus it prevents errors like <a> within <a>
  const text = get(children, "props.children") || children
  const absoluteMaxWidth = getAbsoluteMaxWidth(maxWidth, parentWidth)
  if (clippedAtWidth >= absoluteMaxWidth) {
    return <span className="ellipsable" style={{ maxWidth }} ref={targetRef} {...props}>
      <Tooltip className="ellipsable-tooltip" title={text}><span>{text}</span></Tooltip>
    </span>
  }

  return (
    <span ref={targetRef} {...props}>
      {text}
    </span>
  )
}

Ellipsable.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
